import { supabase } from '@/integrations/supabase/client';

// List of essential tables to check access for
const TABLES_TO_CHECK = ['profiles', 'escort_profiles', 'messages', 'conversations', 'favorites', 'subscriptions'];

/**
 * Tests read access to essential Supabase database tables.
 */
export const testDatabaseAccess = async () => {
  console.log('Health Check: Testing database table access...');
  const accessResults: Record<string, { success: boolean; error?: string }> = {};
  let allTablesAccessible = true;

  for (const tableName of TABLES_TO_CHECK) {
    try {
      // Attempt to select a single row or just check count
      const { error, count } = await supabase
        .from(tableName)
        .select('*', { count: 'exact', head: true }); // Use head for efficiency

      if (error) {
        // Handle potential errors like table not found (RLS might also block)
        console.error(`Health Check Error: Accessing table ${tableName}:`, error);
        accessResults[tableName] = { success: false, error: error.message };
        allTablesAccessible = false;
      } else {
        // console.log(`Health Check: Successfully accessed table ${tableName}, count: ${count}`);
        accessResults[tableName] = { success: true };
      }
    } catch (testError) {
      console.error(`Health Check Error: Testing table ${tableName} failed unexpectedly:`, testError);
      accessResults[tableName] = {
        success: false,
        error: testError instanceof Error ? testError.message : 'Unknown error during table access test'
      };
      allTablesAccessible = false;
    }
  }

  const message = allTablesAccessible
    ? 'Successfully accessed all essential database tables'
    : 'Failed to access one or more essential database tables';
  console.log(`Health Check: Database access test result - ${message}`);

  return {
    success: allTablesAccessible,
    message: message,
    accessResults: accessResults
  };
}; 